export type Singleton<T> = {
    (): T;
};

export function singleton<T>(loader: () => T): Singleton<T> {
    let value: T;
    let loaded = false;

    return () => {
        if (!loaded) {
            value = loader();
            loaded = true;
        }

        return value;
    };
}
